import styles from "../Index.module.css";

export default function Index({enterLog}) {
  return (
    <div className={styles.page}>
      <div className={styles.introBox}>
        <h1>FA/18 Maintenance Log</h1>

        <p>
          The FA/18&apos;s need maintenance and you&apos;re the only one that can
          do it.
        </p>
        <p>Please click below to proceed to the summary of reports.</p>

        <button onClick={enterLog}>Enter Maintenance Log</button>
      </div>
    </div>
  );
}